// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SearchBar_wrapper__RNwgD","input":"SearchBar_input__uPxco","clear":"SearchBar_clear__TP2F2"};